export default __webpack_public_path__ + "static/media/f014374a9730fb7824632e60c6da4f0a1581594400594.6bc33cf6.webp";